<template>
  <div id="home-wrapper">
    <div
      :style="{ backgroundImage: `url(${cardLine1})` }"
      class="cards-line cards-line-1"
    />
    <div
      :style="{ backgroundImage: `url(${cardLine2})` }"
      class="cards-line cards-line-2"
    />
    <div
      :style="{ backgroundImage: `url(${cardLine3})` }"
      class="cards-line cards-line-3"
    />
    <div
      :style="{ backgroundImage: `url(${cardLine1})` }"
      class="cards-line cards-line-2"
    />
    <v-img
      id="home-background"
      :src="homeBackground"
      alt="wave background"
      position="top left"
    />
    <div
      id="home-content"
      class="text-center"
    >
      <h2
        class="text-h3 my-3"
      >
        {{ $t('home.enter_the_arena') }}
      </h2>
      <h3
        id="home-subtitle"
        class="text-h5"
      >
        {{ $t('home.leagues_score_dice_cups') }}
      </h3>
      <v-btn
        size="x-large"
        color="accent"
        href="/login"
        class=" my-6"
      >
        {{ $t('home.start_playing_now') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import cardLine1 from '@/assets/cards-line1.png';
import cardLine2 from '@/assets/cards-line2.png';
import cardLine3 from '@/assets/cards-line3.png';
import homeBackground from '@/assets/home-background.png';

export default {
  name: 'Home',
  data() {
    return {
      cardLine1,
      cardLine2,
      cardLine3,
      homeBackground,
    };
  },
};
</script>

<style scoped>
.cards-line {
  height: 240px;
  background-repeat: repeat-x;
  background-position: top;
  filter: drop-shadow(0 0 8px #ffffff87);
}

.cards-line-1 {
  animation: slideX 60s linear 0s infinite;
}

.cards-line-2 {
  animation: slideXreversed 60s linear 0s infinite;
}

.cards-line-3 {
  animation: slideX 80s linear 0s infinite;
}

#home-wrapper {
  height: 100%;
}

#home-content {
  width: 500px;
  position: absolute;
  top: 0;
  left: 0;
}

#home-background {
  width: 600px;
  height: 400px;
  position: absolute;
  top: 0;
  left: 0;
}

#home-subtitle {
  word-spacing: 5px;
}

@media (max-width: 600px) {
  #home-content {
    width: 100%;
  }

  #home-background {
    height: 350px;
  }
}

@keyframes slideX {
  from { background-position-x: 0; }
  to { background-position-x: 2400px; }
}

@keyframes slideXreversed {
  from { background-position-x: 0; }
  to { background-position-x: -2400px; }
}
</style>
